"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueBreadcrumbReplyDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const VenueBreadcrumb_dto_1 = require("./VenueBreadcrumb.dto");
const VenueBreadcrumbReactionSummary_dto_1 = require("./VenueBreadcrumbReactionSummary.dto");
class VenueBreadcrumbReplyDto {}
exports.VenueBreadcrumbReplyDto = VenueBreadcrumbReplyDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueBreadcrumbReplyDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueBreadcrumbReplyDto.prototype, "content", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueBreadcrumbReplyDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueBreadcrumb_dto_1.VenueBreadcrumbAuthorDto
}), __metadata("design:type", VenueBreadcrumb_dto_1.VenueBreadcrumbAuthorDto)], VenueBreadcrumbReplyDto.prototype, "author", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], VenueBreadcrumbReplyDto.prototype, "isAuthor", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueBreadcrumbReactionSummary_dto_1.VenueBreadcrumbReactionSummaryDto,
  isArray: true
}), __metadata("design:type", Array)], VenueBreadcrumbReplyDto.prototype, "reactions", void 0);
//# sourceMappingURL=VenueBreadcrumbReply.dto.js.map